export default "__VITE_ASSET__a4066745__"